import type { Color } from 'src/types/theme';

export const info: Color = {
  50: '#f2f8ff',
  100: '#d2e4f9',
  200: '#adcff5',
  300: '#89b9f0',
  400: '#65a4ec',
  500: '#408ee7',
  600: '#1a71d5',
  700: '#1457a3',
  800: '#0e3c71',
  900: '#082240',
};
